import { createStore } from "vuex";
import { bookingStore } from "./booking";
import { adminStore } from "./admin";
import VuexPersistence from "vuex-persist";
import * as ENV from '@/config.js'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => {
    // Exclude only venueSettings and bundleVenueSettings from localStorage persistence
    // Keep venueOptions (from new API endpoint)
    const stateCopy = JSON.parse(JSON.stringify(state));
    
    // Remove old venue settings from all modules
    Object.keys(stateCopy).forEach(moduleKey => {
      if (stateCopy[moduleKey]) {
        delete stateCopy[moduleKey].venueSettings;
        delete stateCopy[moduleKey].bundleVenueSettings;
        // venueOptions is now persisted
      }
    });
    
    return stateCopy;
  }
});

let module ={
  admin: adminStore,
  booking: bookingStore,
}
module = {
  [`${ENV.VUE_APP_FACILITY}_admin`]: adminStore,
  [`${ENV.VUE_APP_FACILITY}_booking`]: bookingStore
};


export const store = createStore(
  {
  modules: module,
  state() {
    return {};
  },
  getters: {},
  mutations: {},
  actions: {},
  plugins: [vuexLocal.plugin],
}
);